import { Vue, Component } from 'vue-property-decorator';
@Component
export default class GroupsPopupColumns extends Vue {
  public GroupsPopupColumns: any = {
    '운영자명': {
      header: '운영자명',
      name: 'adminName',
      align: 'center',
      minWidth: 139,
      formatter: function (data: any): any {
        if (data.value) {
          return data.value
        } else {
          return ''
        }
      }
    },
    '직급': {
      header: '직급',
      name: 'jobPositionName',
      align: 'center',
      minWidth: 69,
      formatter: function (data: any): any {
        if (data.value) {
          return data.value
        } else {
          return ''
        }
      }
    },
    '소속부서': {
      header: '소속부서',
      name: 'departmentName',
      align: 'center',
      minWidth: 119,
      formatter: function (data: any): any {
        if (data.value) {
          return data.value
        } else {
          return ''
        }
      }
    },
    '직책': {
      header: '직책',
      name: 'jobDutyName',
      align: 'center',
      minWidth: 119,
      formatter: function (data: any): any {
        if (data.value) {
          return data.value
        } else {
          return ''
        }
      }
    },
    '권한 등록일시': {
      header: '권한 등록일시',
      name: 'authorityRegisteredDateTime',
      align: 'center',
      minWidth: 161,
      formatter: function (data: any): any {
        if (data.value) {
          return data.value
        } else {
          return ''
        }
      }
    }
  }
}